// Node modules
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';

// Components
import Button from '@/components/global-components/Button';

// Themes
import theme from '@/themes/index';

const defaultProps = {
  description: '',
  imageUrl: '',
  title: '',
};

const propTypes = {
  description: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const StoryOfCPI = ({
  content: {
    description,
    image,
    title,
    button,
  }, 
}) => (
  <>
    <div className='container'>
      <img className='story-picture' src={image.url} />
      <div className='details-container'>
        <h4 className='title'>{title}</h4>
        <RichText render={description} />
        {button && 
          <Button
            text={button.title}
            href={button.url}
            target={button.openInAnotherPage ? '_blank' : '_self'}
            className={button.style.toLowerCase()}
            width='9.125rem'
            styles={{
              margin: 'auto', fontSize: '0.875rem', textAlign: 'center', maxWidth: '14rem', width: '14rem', marginTop: '1.8rem', 
            }}
          />
        }
      </div>
    </div>
    <style jsx>{`
      .container {
        background: ${theme.backgroundColors.secondary} 0% 0% no-repeat padding-box;
      }
      
      .details-container {
        padding: 1rem;
        margin-bottom: 3rem;
      }
      .title {
        text-align: center;
        font-family: ${theme.fontFamilies.montserratSemiBold};
      }
      img.story-picture {
        width: 100%;
        height: 32rem;
        object-fit: cover;
        object-position: 0% 10%;
      }
      @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
        .title {
          line-height: 56px;
        }
      }
      @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
        .container {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        
        .details-container {
          padding: 0rem 12.625rem;
        }
      }
    `}</style>
    <style global jsx>{`
      div.container .details-container p {
        font-family: ${theme.fontFamilies.montserrat};
        text-align: justify;
      }
      @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
        div.container .details-container p {
          font-family: ${theme.fontFamilies.openSans};
        }
      }
    `}</style>
  </>
);

StoryOfCPI.propTypes = propTypes;
StoryOfCPI.defaultProps = defaultProps;

export default StoryOfCPI;
